// /arena/new — real route. Mirrors apps/web's app/arena/new/page.tsx: a
// static server-component wrapper (metadata only) around
// `NewExperimentClient`, so we mount the real client component directly
// (same rationale as routes/arena-list.tsx). Registered from
// routes/admin.tsx under the `_admin` guard (routes/guards.tsx), parity
// with app/arena/layout.tsx:7-8.
import { createRoute } from '@tanstack/react-router';
import { NewExperimentClient } from '@/app/arena/new/new-experiment-client';
import { adminRoute } from './guards';

export const arenaNewRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: '/arena/new',
  component: NewExperimentClient,
});
